import { Pipe, PipeTransform } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url, forStyle = false) {
    return forStyle
      ? this.sanitizer.bypassSecurityTrustStyle(`url(${url})`)
      : this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
